

/*
* Asbestos Trust Fund - Updates content based on the selected fund and toggles the additional form to show/hide
*/

// Bail out if not found
if(document.querySelector(".c-trusts-widget__select") == null){
    //return '';
}


// When the input is changed update the trust fund content and show it else hide the content
document.addEventListener('change', function(event){
    if(event.target.matches('.c-trusts-widget__select')){
        var fund = event.target.querySelector('option:checked'),
                    fName = fund.value,
                    fVal = fund.textContent;

        if(fVal == 'Select Trust...'){ 
            document.querySelector('.js-showTrustFundResults').style.display = "none";
            return;
        }
        document.querySelector('.js-trustFundName').textContent = (fVal == 'Other') ? 'Don\'t see your company listed?' : fName+': ';
        document.querySelector('.js-trustFundValue').textContent = (fVal == 'Other') ? '' : fVal;
        document.querySelector('.js-trustFundContent').textContent = (fVal == 'Other') ? 'Let\'s figure out if a trust exists, as well as other legal options. ' : 'Wondering if you qualify? Let us help you find out!';
        document.querySelector('.js-showTrustFundResults').style.display = "block";
    }
});